const AUTHENTICATION_API_ROOT = '/auth';

export const PUBLIC_AUTHENTICATION_API_PATHS = {
  LOGIN: `${AUTHENTICATION_API_ROOT}/login`,
  SIGNUP: `${AUTHENTICATION_API_ROOT}/signup`,
  FORGOT_PASSWORD: `${AUTHENTICATION_API_ROOT}/forgot-password`,
  RESET_PASSWORD: `${AUTHENTICATION_API_ROOT}/reset-password`,
  ME: `${AUTHENTICATION_API_ROOT}/me`,
};

export const PUBLIC_AUTHENTICATION_APP_PATHS = {
  LOGIN: '/v2/connexion',
  SIGNUP: '/v2/inscription',
  FORGOT_PASSWORD: '/v2/mot-de-passe-oublie',
  RESET_PASSWORD: '/v2/reinitialiser-mot-de-passe/:token',
};
